import { ModelPage } from './ModelPage';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { MODEL_SEPARATOR } from './constants';
import { RootCategoriesPage } from './RootCategoriesPage';
import { CategoriesPage } from './CategoriesPage';
import { MaintenanceSchedules } from 'app/pages/MaintenanceSchedulePage';
import { MaintenanceDetails } from 'app/pages/MaintenanceSchedulePage/Details';
import { selectCurrentLanguage } from 'services/slices/locale';
import { useAppSelector } from 'services/store';

const MAINTENANCE_SLUG = 'maintenanceSchedule';

export default function ResourceDispatcher() {
  const params = useParams();
  const pathString = params['*'];
  const navigate = useNavigate();
  const language = useAppSelector(selectCurrentLanguage);
  const previousLanguageRef = React.useRef(language);

  React.useEffect(() => {
    const previousLanguage = previousLanguageRef.current;
    const hasLanguageChanged = previousLanguage !== language;
    const isNestedResourcesPath = Boolean(pathString);

    if (hasLanguageChanged && isNestedResourcesPath) {
      navigate('/resources', { replace: true });
    }

    previousLanguageRef.current = language;
  }, [language, pathString, navigate]);

  if (!pathString) {
    return <RootCategoriesPage />;
  }

  const isModelContext = pathString.includes(MODEL_SEPARATOR);

  if (isModelContext) {
    const [categoryPath, modelContextPath] = pathString.split(MODEL_SEPARATOR);

    const segments = modelContextPath.split('/').filter(Boolean);

    const modelId = segments[0];
    const subRoute = segments[1];
    const subParam = segments[2];

    if (subRoute === MAINTENANCE_SLUG && subParam) {
      return <MaintenanceDetails modelId={modelId} interval={subParam} />;
    }

    if (subRoute === MAINTENANCE_SLUG) {
      return <MaintenanceSchedules modelId={modelId} />;
    }

    return <ModelPage modelId={modelId} categoryPath={categoryPath} />;
  }

  return <CategoriesPage categoryPath={pathString} />;
}
